var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 108,
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.00391,
    y: 0.834961,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.67057,
    y: 1.50163,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#D9D9D9",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0052 47.5017C79.0994 47.5017 82.0669 46.2726 84.2548 44.0846C86.4427 41.8967 87.6719 38.9293 87.6719 35.8351V28.0573C87.6719 24.9631 86.4427 21.9956 84.2548 19.8077C82.0669 17.6198 79.0994 16.3906 76.0052 16.3906H29.3385C26.2443 16.3906 23.2769 17.6198 21.089 19.8077C18.901 21.9956 17.6719 24.9631 17.6719 28.0573V35.8351C17.6719 38.9293 18.901 41.8967 21.089 44.0846C23.2769 46.2726 26.2443 47.5017 29.3385 47.5017M76.0052 47.5017H29.3385M76.0052 47.5017C79.0994 47.5017 82.0669 48.7309 84.2548 50.9188C86.4427 53.1067 87.6719 56.0742 87.6719 59.1684V66.9462C87.6719 70.0404 86.4427 73.0078 84.2548 75.1958C82.0669 77.3837 79.0994 78.6128 76.0052 78.6128H29.3385C26.2443 78.6128 23.2769 77.3837 21.089 75.1958C18.901 73.0078 17.6719 70.0404 17.6719 66.9462V59.1684C17.6719 56.0742 18.901 53.1067 21.089 50.9188C23.2769 48.7309 26.2443 47.5017 29.3385 47.5017M33.2274 31.9462V31.9851M33.2274 63.0573V63.0962",
    stroke: "black",
    strokeWidth: 3.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2619",
    x: 0.670573,
    y: 0.834961,
    width: 103.999,
    height: 106.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.6a275a39d1c3810f372124d205efd9de.svg";
export { ForwardRef as ReactComponent };